import { LoggedOutPageContainer } from "components/pageLayouts/pageLayouts.styled";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { CircularProgress } from "@material-ui/core";
import { Heading } from "components/designV2/heading/heading";
import {
  PageHeaderRow,
  PageLayout,
} from "components/designV2/layout/pageLayout";
import { StatusBanner } from "components/designV2/statusBanner/statusBanner";
import { ColorV2 } from "config/colors";
import { useTranslation } from "react-i18next";
import { SalaryTabs } from "web-apps/company/components/salary/salaryTabs.component";

export const SalaryPage = (): JSX.Element => {
  const [companyState] = useCompanyStore();
  const [authState] = useCompanyStore();
  const { t } = useTranslation();

  return (
    <PageLayout>
      <PageHeaderRow>
        <Heading level="h2">{t("Salary.Salary")}</Heading>
      </PageHeaderRow>
      {authState.isLoading || companyState.isLoading ? (
        <LoggedOutPageContainer>
          <CircularProgress />
        </LoggedOutPageContainer>
      ) : companyState.company?.verified ? (
        <SalaryTabs />
      ) : (
        <StatusBanner
          iconName="v2/clock"
          label={t("GigsCompany.UnverifiedAccount")}
          subLabel={t("GigsCompany.UnverifiedAccountDetails")}
          textColor={ColorV2.NegativeRed}
          backgroundColor={ColorV2.White}
        />
      )}
    </PageLayout>
  );
};